<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.family_interviews', 2),
                        href: meta.links.index,
                    },
                    {
                        name: student.group_name,
                        href: meta.links.index_group,
                    },
                    {
                        name: $t('messages.student'),
                        href: meta.links.index_student,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <InertiaLink :href="meta.links.student_show">
                        <img
                            :src="student.avatar_or_default"
                            class="mx-auto rounded-full h-32 w-32 border-4 border-white"
                            alt=""
                        />
                    </InertiaLink>

                    <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
                        <div class="flex flex-col justify-center items-center">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                <InertiaLink :href="meta.links.student_show">
                                    {{ student.name_or_nickname }}
                                </InertiaLink>
                            </h3>
                            <h3 class="leading-6 font-base text-gray-600">
                                {{ $t('messages.student') }}
                            </h3>
                        </div>
                        <div class="mt-3 flex space-x-1">
                            <AppButton element="inertia-link" :href="meta.links.edit" v-if="meta.can.edit">
                                {{ $t('messages.edit') }}
                            </AppButton>
                            <AppButton element="a" :href="meta.links.print">
                                {{ $t('messages.print') }}
                            </AppButton>
                        </div>
                    </div>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.date')" for="date" />
                            <div>
                                {{ familyInterview.date }}
                            </div>
                        </div>
                    </div>

                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.duration')" for="duration" />
                            {{ familyInterview.duration_letters }}
                        </div>
                    </div>

                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.type')" for="type_id" />
                            <div>
                                {{ familyInterview.type_string }}
                            </div>
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.participants')" for="participants" />
                            <p class="whitespace-pre-line">{{ familyInterview.participants }}</p>
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.requested_by')" for="requested_by" />
                            <div>{{ familyInterview.requested_by }}</div>
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.reason')" for="reason" />
                            <div>
                                {{ familyInterview.reason }}
                            </div>
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.topics_covered')" for="topics_covered" />
                            <p class="whitespace-pre-line">{{ familyInterview.topics_covered }}</p>
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.agreements_purposes')" for="agreements_purposes" />
                            <p class="whitespace-pre-line">{{ familyInterview.agreements_purposes }}</p>
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.links', 2)" for="links" />
                            <LinkList :links="familyInterview.links" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import LinkList from '@/components/LinkList.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        FormLabel,
        LinkList,
        AppButton,
    },
    layout: Layout,
    name: 'Show',
    props: ['teacher', 'meta', 'options', 'student', 'familyInterview'],
};
</script>
